<template>
  <!-- Every certificate category this person has, wrapped onto as many lines as needed so the
       whole list is visible at once (no horizontal scrolling) and the selected one is always on
       screen, highlighted. -->
  <b-nav
    pills
    class="personnel-category-nav justify-content-center mb-1"
  >
    <b-nav-item
      v-for="item in technicalReg"
      :key="item.id"
      :active="item.active"
      @click="setActiveTab(item.id)"
    >
      {{ item.name }}
    </b-nav-item>
  </b-nav>
</template>

<script>
export default {
  props: {
    technicalReg: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    setActiveTab(id) {
      this.$emit('tab-selected', id)
    },
  },
}
</script>

<style scoped>
.personnel-category-nav {
  flex-wrap: wrap;
  row-gap: 0.4rem;
}
.personnel-category-nav ::v-deep .nav-link {
  white-space: normal;
  padding: 0.35rem 0.8rem;
  border: 1px solid rgba(115, 103, 240, 0.35);
  margin-right: 0.4rem;
}
.personnel-category-nav ::v-deep .nav-link.active {
  font-weight: 600;
}
</style>
